import React, { useState } from "react";
import { Paper, BottomNavigation, BottomNavigationAction } from "@mui/material";
import { useNavigate } from "react-router";
import { useResponsive } from "../../hooks/useResponsive";
import storePersist from "../../services/localStorage";
import { localConstant } from "../../services/localStorage";
import { useTranslation } from "react-i18next";
import NavIcons from "../../assets/Icon/NavIcons";

const BottomNav = ({ activeTab = 0 }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const lgUp = useResponsive("up", "lg");
  const [value, setValue] = useState(activeTab);
  const userType = storePersist.get(localConstant.USER_PROFILE);

  const ownerConfig = [
    {
      label: t("components.bottomNavigation.item01"),
      iconImg: NavIcons.HomeIcon,
      navTo: "/ownerDashboard",
    },
    {
      label: t("components.bottomNavigation.item02"),
      iconImg: NavIcons.ReservationIcon,
      navTo: "/reservation",
    },
    {
      label: t("components.bottomNavigation.item03"),
      iconImg: NavIcons.MyVehiclesIcon,
      navTo: "/vehiclesList",
    },
    {
      label: t("components.bottomNavigation.item04"),
      iconImg: NavIcons.MyDriversIcon,
      navTo: "/driversList",
    },
  ];

  const driverConfig = [
    {
      label: t("components.bottomNavigation.item01"),
      iconImg: NavIcons.HomeIcon,
      navTo: "/operatorDashboard",
    },
    {
      label: t("components.bottomNavigation.item02"),
      iconImg: NavIcons.ReservationIcon,
      navTo: "/reservation",
    },
  ];

  const config = userType === "OWNER" ? ownerConfig : driverConfig;
  return (
    <Paper
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        boxShadow: 1,
        backgroundColor: "lightgray",
        display: !lgUp ? "block" : "none",
      }}
    >
      <BottomNavigation
        showLabels={true}
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
      >
        {config.map((data, index) => {
          const NavIcon = data.iconImg;
          return (
            <BottomNavigationAction
              key={index}
              label={data.label}
              onClick={() => {
                navigate(data.navTo);
              }}
              icon={<NavIcon width="22" height="22" active={index === value} />}
            />
          );
        })}
      </BottomNavigation>
    </Paper>
  );
};

export default BottomNav;
